import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/api-client';
import type { GoogleAdsPlacement } from '@low6-pickem/ui';

export const useAdPlacements = (slug: string) => {
  return useQuery({
    queryKey: ['tenant', slug, 'google-ads-placements'],
    queryFn: async (): Promise<GoogleAdsPlacement[]> => {
      const response = await apiClient.get(`/api/tenants/${slug}/google-ads-placements`);
      return (response as any).placements || [];
    },
    enabled: !!slug,
    staleTime: 1000 * 60 * 5,
    retry: 3,
  });
};
